export default __webpack_public_path__ + "static/media/pobeg.f2f65b35.jpeg";